import React from 'react';
import PropTypes from 'prop-types';

// Assets
import Flame from '../../../../assets/images/flame.svg';
import Caret from '../../../../assets/images/caret_down.svg';
import Close from '../../../../assets/images/close.svg';
import CheckMark from '../../../../assets/images/icon-checkmark.svg';
import Chevron from '../../../../assets/images/icon-chevron-right.svg';
import BlueCheckMark from '../../../../assets/images/blue_checkmark.svg';
import BlueBookMark from '../../../../assets/images/blue-bookmark.svg';

const icons = {
  flame(props) {
    // eslint-disable-next-line react/prop-types
    const { style, ...otherProps } = props;

    return (
      <Flame
        data-testid="flame_icon"
        {...otherProps}
        style={{ color: '#B7BFC3', width: '80px', ...style }}
      />
    );
  },

  chevron(props) {
    // eslint-disable-next-line react/prop-types
    const { style, ...otherProps } = props;

    return (
      <Chevron
        data-testid="chevron_icon"
        {...otherProps}
        style={{ color: '#0073b9', width: '20px', ...style }}
      />
    );
  },

  caret(props) {
    // eslint-disable-next-line react/prop-types
    const { style, ...otherProps } = props;

    return (
      <Caret
        data-testid="caret_icon"
        {...otherProps}
        style={{ width: '14px', color: '#0091D9', ...style }}
      />
    );
  },

  close(props) {
    // eslint-disable-next-line react/prop-types
    const { style, ...otherProps } = props;

    return (
      <Close
        data-testid="close_icon"
        {...otherProps}
        style={{ width: '14px', verticalAlign: 'top', ...style }}
      />
    );
  },

  check(props) {
    // eslint-disable-next-line react/prop-types
    const { style, ...otherProps } = props;

    return (
      <CheckMark
        data-testid="checkmark_icon"
        {...otherProps}
        style={{ width: '14px', ...style }}
      />
    );
  },

  blue_check(props) {
    // eslint-disable-next-line react/prop-types
    const { style, ...otherProps } = props;

    return (
      <BlueCheckMark
        data-testid="blue_checkmark_icon"
        {...otherProps}
        style={{ width: '201px', ...style }}
      />
    );
  },

  blue_bookmark(props) {
    // eslint-disable-next-line react/prop-types
    const { style, ...otherProps } = props;

    return (
      <BlueBookMark
        data-testid="blue_bookmark_icon"
        {...otherProps}
        style={{ width: '14px', ...style }}
      />
    );
  }
};

const iconProps = {
  name: PropTypes.string
};
const Icon = (props) => {
  const { name, ...otherProps } = props;

  if (icons.hasOwnProperty(name)) {
    const IconComponent = icons[name];

    return <IconComponent {...otherProps} />;
  }
  // eslint-disable-next-line no-console
  console.warn(`Icon: ${name} not recognized as a component.`);
  return null;
};

Icon.propTypes = iconProps;

export default Icon;
